const IN_EDITOR_TEMPLATES_PANEL_ALLOWED_FEATURES = ['template-browser', 'template-browser-panel'];

const hasAllowedFeature = (feature: unknown, featureName: string): boolean => {
	if (typeof feature === 'string') {
		return feature === featureName;
	}

	if (feature && typeof feature === 'object') {
		return Object.prototype.hasOwnProperty.call(feature, featureName);
	}

	return false;
};

export const isInEditorTemplatesPanelEnabled = (allowedFeatures?: 'all' | unknown[]): boolean => {
	if (allowedFeatures === 'all') {
		return true;
	}

	return (
		allowedFeatures?.some((feature) =>
			IN_EDITOR_TEMPLATES_PANEL_ALLOWED_FEATURES.some((featureName) =>
				hasAllowedFeature(feature, featureName),
			),
		) ?? false
	);
};
